import React from 'react';
import {
  Form,
  Button,
  Segment,
  Header,
  Message,
  Input
} from 'semantic-ui-react';

import logo from '../../assets/logo.png';
import '../../assets/styles/Login.css';

const View = ({ error, loading, email, password, onChange, onSignIn }) => (
  <div className="c-Login">
    <Segment className="c-Login__container" padded loading={loading}>
      <Header className="c-Login__header">
        <img className="c-Login__logo" src={logo} alt="Air Refund logo" />
      </Header>
      <Form error={error}>
        <Form.Input className="c-Login__input" label="login">
          <Input value={email} onChange={onChange} name="email" autoFocus />
        </Form.Input>
        <Form.Input
          className="c-Login__input"
          value={password}
          onChange={onChange}
          name="password"
          label="password"
          type="password"
        />
        {error && (
          <Message
            error
            header="Invalid credentials"
            content="You have entered invalid login or password"
          />
        )}
        <div className="c-Login__btn-container">
          <Button
            className="c-Login__btn"
            onClick={onSignIn}
            primary
            content="Sign in"
          />
        </div>
      </Form>
    </Segment>
  </div>
);

export default View;



// WEBPACK FOOTER //
// ./src/component/LoginPage/View.js